module.exports = __webpack_public_path__ + "img/voltage.f313a177.svg";